import request from '@/utils/request'

export function getList(params) {
  return request({
    url: '/productTypes/load',
    method: 'get',
    params
  })
}

export function add(data) {
  return request({
    url: '/productTypes/add',
    method: 'post',
    data
  })
}

export function update(data) {
  return request({
    url: '/productTypes/update',
    method: 'post',
    data
  })
}

export function del(data) {
  return request({
    url: '/productTypes/delete',
    method: 'post',
    data
  })
}

